import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';

import { UppShortcutEditComponent } from '../components/upp-edit/upp-edit';
import { UppShortcutViewComponent } from '../components/upp-view/upp-view';

@NgModule({
    declarations: [
        UppShortcutEditComponent,
        UppShortcutViewComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        UppBaseModule,
        UppWdgtModule,
        UppDataModule          
    ],
    exports: [
        UppShortcutEditComponent,
        UppShortcutViewComponent
    ],    
    providers: [],  
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]      
})
export class FeatureShortcutModule {}
